
function ChordNotes({ notes }) {
	return (
		<div className="chord-notes">
			{notes.map(note => note.name).join(" ")}
		</div>
	);
}

export default ChordNotes;